export enum TypeOffre {
     /// <summary>
     /// Flux des offres stockées (donc neuves et principales comme STK en v2)
     /// </summary>
     PrincipalStored = 'PrincipalStored',//1,
     /// <summary>
     /// Flux des offres MKP principales neuves uniquement
     /// </summary>
     PrincipalMkpNeuf = 'PrincipalMkpNeuf',//2,
     /// <summary>
     /// Flux des offres MKP principales occasion uniquement
     /// </summary>
     PrincipalMkpOcca = 'PrincipalMkpOcca',//4,
     /// <summary>
     /// Flux des offres MKP principales reconditionnées uniquement
     /// </summary>
     PrincipalMkpReco = 'PrincipalMkpReco',//8,
     // bits 2..3
     /// <summary>
     /// Flux des offres complémentaires MKP neuves (MKP-1)
     /// </summary>
     ExtendMkpNew = 'ExtendMkpNew',//16,
     /// <summary>
     /// Flux des offres complémentaires MKP occasion (MKP-2)
     /// </summary>
     ExtendMkpOcca = 'ExtendMkpOcca', //32,
     /// <summary>
     /// Flux des offres complémentaires MKP reconditionnées (MKP-3)
     /// </summary>
     ExtendMkpReco = 'ExtendMkpReco',//64,
     // Les combinaisons effectivement utilisées
     /// <summary>
     /// Combinaison multiflags: Toutes les offres principales (comme STK + MKP en v2)
     /// </summary>
     CmbPrincipalAll = 'CmbPrincipalAll',//1 + 2 + 4 + 8,
     /// <summary>
     /// Combinaison multiflags: Toutes les offres principales MKP (comme MKP en v2)
     /// </summary>
     CmbPrincipalMkp = 'CmbPrincipalMkp',//2 + 4 + 8,
     /// <summary>
     /// Raccourci multiflags: Tous !
     /// </summary>
     CmbOverall = 'CmbOverall',//127,
     /// <summary>
     /// Combinaison multiflags: Toutes les offres principales neuves donc soit STK soit MKP principales
     /// </summary>
     CmbPrincipalNeuf = 'CmbPrincipalNeuf',//1 + 2,
     /// <summary>
     /// Combinaison multiflags: Toutes les offres MKP neuves (principales et secondaires)
     /// </summary>
     CmbFullMkpNeuf = 'CmbFullMkpNeuf',//2 + 16,
     /// <summary>
     /// Combinaison multiflags: Toutes les offres MKP occasion (principales et secondaires)
     /// </summary>
     CmbFullMkpOcca = 'CmbFullMkpOcca',//4 + 32,
     /// <summary>
     /// Combinaison multiflags: Toutes les offres MKP reconditionnées (principales et secondaires)
     /// </summary>
     CmbFullMkpReco = 'CmbFullMkpReco',//8 + 64
}
